<template>
    <Dialog v-model:visible="visible_" modal header="Списание по подписке" @hide="close"
        class="border-none"
        :style="{ width: '28rem' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">ID подписки</span>
                <span class="text-sm">{{ subscriptionId }}</span>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-xs text-600">Будет выполнено списание по данной подписке.</span>
            </div>
            <div class="flex justify-content-end gap-2 mt-2">
                <Button label="Списать" size="small" severity="warn" :loading="loading" @click="charge" />
                <Button label="Отмена" size="small" severity="secondary" @click="close" />
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'AdminSubscriptionCharge',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        subscriptionId: {
            type: [Number, String],
            required: true
        }
    },
    emits: ['update:modelValue', 'charged'],
    data() {
        return {
            visible_: false,
            loading: false,
        }
    },
    methods: {
        async charge() {
            if (!this.subscriptionId) return
            this.loading = true
            try {
                const resp = await this.connect.ChargeAdminSubscription(this.subscriptionId).then(res => res)
                if (resp && resp.result) {
                    const status = resp.data && resp.data.status ? resp.data.status : 'processing'
                    const message = resp.message || (resp.data && resp.data.message) || 'Списание по подписке запущено'
                    this.$toast.add({ severity: this.helper.getStatusSeverity(status), summary: this.helper.getStatusTitle(status), detail: message, life: 3000 })
                    this.$emit('charged', { id: this.subscriptionId, status })
                    this.close()
                } else {
                    const message = resp && resp.message ? resp.message : 'Не удалось выполнить списание по подписке'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.visible_ = false
            this.$emit('update:modelValue', false)
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                this.visible_ = v
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>